app.controller('profileIndexCtrl', [
    '$scope', '$rootScope', '$http', '$state', 'authService', 'me', '$mdToast', function ($scope, $rootScope, $http, $state, authService, me, $mdToast) {
        var vm = this;

    	vm.model = {
			name: me.name,		
			email: me.email,
			password: '',
			passwordAgain: '',
			form: {}
		};

		vm.save = function () {
            if (!vm.model.form.$valid) {
                return;
            }

            vm.model.submitting = true;

            $http.post('api/me', vm.model)
                .then(function (resp) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent("Profil opdateret")
                        .position('top right')
                        .hideDelay(3000)
                    );
                    $state.go('profile');
                }, function (err) {
                    vm.model.submitting = false;
                    if (err.status === 409) {
                        vm.model.form.name.$setValidity("taken", false);
                    }
                });
        }
    }
]);